import { render, staticRenderFns } from "./no-data-available.vue?vue&type=template&id=0fef5038&scoped=true"
import script from "./no-data-available.vue?vue&type=script&lang=js"
export * from "./no-data-available.vue?vue&type=script&lang=js"
import style0 from "./no-data-available.vue?vue&type=style&index=0&id=0fef5038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fef5038",
  null
  
)

export default component.exports